import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon, ChevronDownIcon, MenuIcon, XIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant44() {
  const {
    language,
    t,
    getPath
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const handleLanguageChange = (lang: 'en' | 'ru' | 'ua') => {
    const currentPath = window.location.pathname;
    let newPath = currentPath;
    if (currentPath.startsWith('/ru')) newPath = currentPath.substring(3) || '/';else if (currentPath.startsWith('/ua') || currentPath.startsWith('/uk')) newPath = currentPath.substring(3) || '/';
    if (lang === 'ru') newPath = `/ru${newPath === '/' ? '' : newPath}`;else if (lang === 'ua') newPath = `/ua${newPath === '/' ? '' : newPath}`;
    window.location.href = newPath;
  };
  const content = {
    ru: {
      title1: 'Сделаем сайт для вас бесплатно.',
      title2: `Обслуживание — ${price}/мес.`,
      sub: `Мы делаем сайт за свой счёт. Вы смотрите, просите правки, утверждаете. Когда всё нравится — платите ${price} в месяц за хостинг и поддержку. Не понравится — просто уходите. Без оплаты.`,
      cta: 'Начать проект'
    },
    ua: {
      title1: 'Зробимо сайт для вас безкоштовно.',
      title2: `Обслуговування — ${price}/міс.`,
      sub: `Ми робимо сайт за свій рахунок. Ви дивитеся, просите правки, затверджуєте. Коли все подобається — платите ${price} на місяць за хостинг та підтримку. Не сподобається — просто йдете. Без оплати.`,
      cta: 'Почати проєкт'
    },
    en: {
      title1: 'We build your website for free.',
      title2: `Maintenance — ${price}/mo.`,
      sub: `We build the site at our expense. You review, request edits, and approve. When you love it, you pay ${price}/month for hosting and support. Don't like it? Just walk away. No charge.`,
      cta: 'Start project'
    }
  }[language] || content.ru;
  return <>
      <section className="relative w-full pt-4 pb-12 px-4 min-h-screen flex flex-col" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-706">
        {/* Massive Rounded Video Container that acts as the whole section background */}
        <div className="relative w-full flex-1 rounded-[2.5rem] overflow-hidden shadow-2xl flex flex-col" data-id="element-707">
          <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-708" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/50 to-transparent" data-id="element-709" />

          {/* Header Inside the Rounded Video */}
          <header className="relative z-50 w-full pt-6 pb-4 px-6 lg:px-12" data-id="element-710">
            <div className="flex items-center justify-between" data-id="element-711">
              <a href={getPath('')} className="flex items-center gap-1 text-white" data-id="element-712">
                <span className="text-2xl font-bold tracking-tight" data-id="element-713">J</span>
                <span className="w-2 h-2 rounded-full bg-blue-500" data-id="element-714" />
              </a>

              <div className="hidden md:flex items-center gap-8" data-id="element-715">
                <a href="#how-it-works" className="text-sm font-semibold text-white/90 hover:text-white transition-colors" data-id="element-716">
                  {t('nav.howItWorks')}
                </a>
                <a href="#services" className="text-sm font-semibold text-white/90 hover:text-white transition-colors" data-id="element-717">
                  {t('nav.pricing')}
                </a>
                <a href="#faq" className="text-sm font-semibold text-white/90 hover:text-white transition-colors" data-id="element-718">
                  {t('nav.faq')}
                </a>
              </div>

              <div className="flex items-center gap-4" data-id="element-719">
                <div className="hidden md:block relative" data-id="element-720">
                  <button onClick={() => setIsLangMenuOpen(!isLangMenuOpen)} className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-white text-sm font-medium transition-all backdrop-blur-md" data-id="element-721">
                    <span className="uppercase" data-id="element-722">{language}</span>
                    <ChevronDownIcon className="w-4 h-4" data-id="element-723" />
                  </button>
                  <AnimatePresence data-id="element-724">
                    {isLangMenuOpen && <motion.div initial={{
                    opacity: 0,
                    y: 10
                  }} animate={{
                    opacity: 1,
                    y: 0
                  }} exit={{
                    opacity: 0,
                    y: 10
                  }} className="absolute top-full mt-2 right-0 rounded-lg bg-white/10 backdrop-blur-xl border border-white/20 overflow-hidden shadow-2xl min-w-[80px]" data-id="element-725">
                        {['en', 'ru', 'ua'].map(lang => <button key={lang} onClick={() => handleLanguageChange(lang as any)} className={`w-full px-4 py-2 text-left text-sm font-medium transition-colors ${language === lang ? 'bg-blue-600 text-white' : 'text-white hover:bg-white/10'}`} data-id="element-726">
                            {lang.toUpperCase()}
                          </button>)}
                      </motion.div>}
                  </AnimatePresence>
                </div>
                <button onClick={() => setIsPopupOpen(true)} className="hidden md:block px-6 py-2.5 rounded-lg text-sm font-semibold transition-all hover:scale-105 bg-white text-gray-900" data-id="element-727">
                  {t('nav.getStarted')}
                </button>
                <button className="md:hidden p-2 text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-728">
                  {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-729" /> : <MenuIcon className="w-6 h-6" data-id="element-730" />}
                </button>
              </div>
            </div>
          </header>

          {/* Left-Aligned Content */}
          <div className="relative z-10 flex-1 flex items-center px-6 lg:px-12" data-id="element-731">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.8
          }} className="max-w-3xl" data-id="element-732">
              <h1 className="mb-4 text-5xl md:text-6xl lg:text-[5rem] font-black leading-[1.1] text-white tracking-tight" data-id="element-733">
                {content.title1}
              </h1>
              <h2 className="mb-8 text-3xl md:text-4xl font-bold text-blue-400" data-id="element-734">
                {content.title2}
              </h2>
              <p className="text-lg md:text-xl mb-10 text-gray-300 font-medium leading-relaxed max-w-2xl border-l-4 border-blue-500 pl-6" data-id="element-735">
                {content.sub}
              </p>
              <button onClick={() => setIsPopupOpen(true)} className="group inline-flex items-center justify-center gap-2 rounded-2xl px-10 py-5 font-bold text-lg transition-all hover:scale-105 bg-blue-600 text-white hover:bg-blue-500 shadow-xl shadow-blue-600/30" data-id="element-736">
                {content.cta}
                <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-737" />
              </button>
            </motion.div>
          </div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-738" />
    </>;
}